var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          stripe: false,
          selection: _vm.selection,
          "right-toolbar-hide": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessOrderPreemptGoodsSku.preemptionStatus"
                            ),
                            prop: "preemptionStatus",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "constant-key":
                                "ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST",
                            },
                            model: {
                              value: _vm.queryParams.preemptionStatus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "preemptionStatus",
                                  $$v
                                )
                              },
                              expression: "queryParams.preemptionStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessOrderPreemptGoodsSku.sourceStatus"
                            ),
                            prop: "sourceStatus",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "constant-key":
                                "ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST",
                            },
                            model: {
                              value: _vm.queryParams.sourceStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "sourceStatus", $$v)
                              },
                              expression: "queryParams.sourceStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            _vm.hasBtn
              ? {
                  key: "startBtnGroup",
                  fn: function () {
                    return [
                      !_vm.success
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.onAction(
                                    _vm.$t(
                                      "BusinessOrderPreemptGoodsSku.reReserve"
                                    )
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessOrderPreemptGoodsSku.reReserve"
                                  )
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderPreemptGoodsSku.Uncamp")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessOrderPreemptGoodsSku.Uncamp")
                            )
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _c("el-table-column", {
                    attrs: {
                      prop: "preemptionStatus",
                      label: _vm.$t(
                        "BusinessOrderPreemptGoodsSku.preemptionStatus"
                      ),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(
                                      scope.row.preemptionStatus
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuName",
                      label: _vm.$t("goodsPage.skuName"),
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      label: _vm.$t("goodsPage.skuCode"),
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: _vm.$t("BusinessOrderPreemptGoodsSku.quantity"),
                      width: "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "suspendStatus",
                      label: _vm.$t("BusinessOrderPreemptGoodsSku.hangUp"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST.bjGet(
                                      scope.row.suspendStatus
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "giftFlag",
                      label: _vm.$t("BusinessOrderPreemptGoodsSku.giveaway"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: scope.row.giftFlag ? "success" : "info",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.STATUS_YES_NUM.bjGet(
                                        !!scope.row.giftFlag
                                      )
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sourceStatus",
                      label: _vm.$t(
                        "BusinessOrderPreemptGoodsSku.sourceStatus"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(
                                      scope.row.sourceStatus
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "virtualWarehouseName",
                      label: _vm.$t(
                        "BusinessOrderPreemptGoodsSku.virtualWarehouseName"
                      ),
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "failReason",
                      label: _vm.$t("BusinessOrderPreemptGoodsSku.failReason"),
                      "min-width": "300",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }